/**
 * WARNING: The use of `require` and `module.exports` is because this package has to remain
 * in CommonJS format. Do not change ANY files here to ES6 standards or it will break usages.
 */

"use strict";

const {getStack} = require("./api.js");

module.exports = {
  getStack
};
